module.exports = __webpack_public_path__ + "img/photo2.31725b5c.jpg";